import { UUID } from 'ComponentLibrary/src/common/uuid'
import { createContext, ReactNode, useContext } from 'react'

export type TaskSideDrawerContextType = {
    taskId: UUID | undefined
    openTaskSideDrawer: (taskId: UUID) => void
    closeTaskSideDrawer: () => void
}

const TaskSideDrawerContext = createContext<TaskSideDrawerContextType>({
    taskId: undefined,
    openTaskSideDrawer: () => {},
    closeTaskSideDrawer: () => {},
})

type TaskSideDrawerProviderProps = {
    children: ReactNode
    taskSideDrawerState: TaskSideDrawerState
}

type TaskSideDrawerState = {
    openTaskId: UUID | undefined
    setOpenTaskId: (taskId: UUID | undefined) => void
}

export const TaskSideDrawerProvider = ({ children, taskSideDrawerState }: TaskSideDrawerProviderProps) => {
    const { openTaskId, setOpenTaskId } = taskSideDrawerState

    const openTaskSideDrawer = (taskId: UUID) => {
        setOpenTaskId(taskId)
    }

    const closeTaskSideDrawer = () => {
        setOpenTaskId(undefined)
    }

    return (
        <TaskSideDrawerContext.Provider value={{ taskId: openTaskId || undefined, openTaskSideDrawer, closeTaskSideDrawer }}>
            {children}
        </TaskSideDrawerContext.Provider>
    )
}

export function useTaskSideDrawer() {
    const context = useContext(TaskSideDrawerContext)
    if (context === null) {
        throw new Error('TaskSideDrawerContext must be used within a TaskSideDrawerProvider')
    }
    return context
}
